export enum EventTrackingEnum {
  DOWNLOAD_ORIENTATION_FROM_WHATSAPP = 6,
  SEND_ORIENTATION_FROM_WHATSAPP = 8
}
